import type { ReactNode } from 'react';

export const symbol_pacemaker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M158-118q-38-38-38-92v-341q-24-23-52-49.5T40-664q0-23 16.5-39.5T96-720q17 0 30 9t24 21q11-12 24.5-21t29.5-9q23 0 39.5 16.5T260-664q0 37-28 63.5T180-551v341q0 29 20.5 49.5T250-140q29 0 49.5-20.5T320-210v-475q0-81 57-138t138-57q81 0 138 57t57 138v7q72 11 121 67t49 131v200q0 83-58.5 141.5T680-80q-83 0-141.5-58.5T480-280v-200q0-75 49-131t121-67v-7q0-57-39-96t-96-39q-57 0-96 39t-39 96v475q0 54-38 92t-92 38q-54 0-92-38Zm621-63q41-41 41-99v-200q0-58-41-99t-99-41q-58 0-99 41t-41 99v200q0 58 41 99t99 41q58 0 99-41ZM623.5-336.5Q600-313 600-280t23.5 56.5Q647-200 680-200t56.5-23.5Q760-247 760-280t-23.5-56.5Q713-360 680-360t-56.5 23.5ZM680-280Z"
		/>
	</svg>
);
